// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__qqB43","row":"styles_row__3m_Em"};